import {formData,globals as gl} from './globals'
// Modal ########################################################################################################
export function generateModal(text) {
  
   
      let $modal = $('<div />', {
        'id': `modal-a`,
        'class': 'modal fade',
        'tabindex': '-1',
        'role': 'dialog'
      });

      let $modalDialog = $('<div />', {
        'id': 'modal-dialog-a',
        'class': 'modal-dialog',
        'role': 'document'
      }).appendTo($modal);

      let $modalContent = $('<div />', {
        'id': 'modal-content-a',
        'class': 'modal-content',
        'html': `<div class="modal-body">
                  ${text}
                </div>`
      }).appendTo($modalDialog);

      let $modalFooter = $('<div />', {
        'class': 'modal-body text-center',
        'id': 'btn-holder-a'
      }).appendTo($modalContent);

      $('<input />', { //agree btn
        type: 'button',
        value: 'Ok',
        'data-dismiss':'modal',
        'class': 'btn btn-primary',
        'id': `ok-a`
      }).click((function (e) {
        return function (e){
          e.preventDefault();
          $('#newsletter-form .checkbox-custom-label').removeClass('error');        // zrusime error oznaceni vsech checkboxu, ze nebyl zadny vyplnen
        };
        
      })()).appendTo($modalFooter);
      return $modal;
}
// Modal ########################################################################################################



// WEBPACK FOOTER //
// ./app/modal.js